import React, { Component} from "react";
import Titulo from "../../generico/TituloPagina";
import DataTable from 'react-data-table-component';
import { formatoSeparadorMilesValue } from '../../generico/utils/FormatoInput'
import DatosSocio from "../../generico/DatosSocio"
import ExcedenteService from "../../../services/consultas/excedenteService";
import { trackPromise } from "react-promise-tracker";
import authService from "../../../services/login/auth.service";
import Select from "react-select";
import Popup from "react-popup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck  } from "@fortawesome/free-solid-svg-icons";

const conditionalRowStyles = [
  {
    when: row => row.concepto === "Total:",
    style: {
      backgroundColor: '#fafafa',
      fontSize: 'initial'
    },
  },
  {
    when: row => row.concepto === "Total distribuido:",
    style: {
      backgroundColor: '#fafafa',
      fontSize: 'initial'
    },
  }
];


export default class Excedente extends Component {

  

  constructor(props) {
    super(props);
    this.state = {
      listaDetalle: [],
      listaResumen: [],
      listaEjercicio: [],
      ejercicioElegido: null
    };
  }
  
  componentDidMount() {
  

  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  obtenerEjercicio = () => {
    var ejercicio = [];
    trackPromise(
      ExcedenteService.fechas("WEB")
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(jsonData)
          if (jsonData.codigo === "0") {
            ejercicio.push({
              value: null,
              label: "Seleccione",
            });
            for (var i = 0; i < jsonData.resultados.length; i++) {
              ejercicio.push({
                value: jsonData.resultados[i].ejercicio,
                label: jsonData.resultados[i].ejercicio,
              });
            }
            this.setState({ listaEjercicio: ejercicio });
          }
          else {
            Popup.queue(this.notifiPopup("Info", jsonData.mensaje));
            return;
          }
          return ejercicio;
        }

        ).catch(function (error) {
         // console.log(error)
          authService.logout()
        })
    );

  }



  getEjercicioExcedente() {
    if (this.state.listaDetalle.length === 0) {
      return (
        <div></div>
      );
    }

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="card" style={{zIndex: 2}}>
            <div className="card-header">
              <DatosSocio />
    <span>Ejercicio {this.state.ejercicioElegido}</span>
            </div>
            <div className="card-body">
              <div className="row seccion-excedente">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <DataTable
                      title="Distribución de Excedente"
                      columns={this.getColumn()}
                      data={this.state.listaDetalle}
                      dense={true}
                      noDataComponent="no hay registros para mostrar"
                      noTableHead={true}
                      conditionalRowStyles={conditionalRowStyles} />
                  </div>
                </div>
              </div>
              <br />
              {this.state.listaResumen.length > 0 ? <div className="row seccion-excedente">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <DataTable
                      title="Acreditación"
                      columns={this.getColumnResumen()}
                      data={this.state.listaResumen}
                      dense={true}
                      noDataComponent="no hay registros para mostrar"
                      noTableHead={true}
                      conditionalRowStyles={conditionalRowStyles} />
                  </div>
                </div>
              </div>:<div></div>}
            </div>
          </div>
        </div>
      </div>
    );
  }

  handleChangeEjercicioSelector = (selectedOption) => {
    if (selectedOption === null)
      this.setState({
        ejercicioElegido: null, listaDetalle: [], listaResumen:[]
      });
    else{
      this.setState({
        ejercicioElegido: selectedOption.value
      })
  
  }
  }

  getColumn() {
    return [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector: row => row.valor,
      }]
  }

  getColumnResumen() {
    return [
      {
        name: "Cuenta",
        selector: row => row.cuenta,
      },
      {
        name: "Módulo",
        selector: row => row.modulo,
      },
      {
        name: "Monto",
        selector: row => row.monto,
      }]
  }

 

  getListaResumen() { 

    var respuesta = [];
    var detalle = [];
    trackPromise(
      ExcedenteService.excedentes(this.state.ejercicioElegido)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          if (jsonData.codigo === "0") {
            respuesta.push({
              concepto: "Cédula de Identidad / Nro de socio:",
              valor: authService.getCurrentUser().cedulaIdentidad + " / " + authService.getCurrentUser().numeroSocio},
              { concepto: "Interés / Aportes GS:", valor: formatoSeparadorMilesValue(jsonData.aporte) + " GS." },
              { concepto: "Retorno / Ahorros GS:", valor: formatoSeparadorMilesValue(jsonData.ahorro) + " GS." },
              { concepto: "Retorno / Créditos + Tarjetas GS:", valor: formatoSeparadorMilesValue(jsonData.credito) + " GS." },
              { concepto: "Total:", valor: formatoSeparadorMilesValue(jsonData.total) + " GS." }
            );
            if(jsonData.resultados !== null){
              for (var i = 0; i < jsonData.resultados.length; i++) {
              detalle.push(
               
                { cuenta: jsonData.resultados[i].cuenta,
                  modulo: jsonData.resultados[i].modulo,
                  monto: formatoSeparadorMilesValue(jsonData.resultados[i].monto)+" "+jsonData.resultados[i].moneda,
                  }
              );
            }
          }
            this.setState({ listaDetalle: respuesta, listaResumen: detalle });
          }
          else {
            this.setState({ listaDetalle: [], listaResumen: [] });
            Popup.queue(this.notifiPopup("Info", jsonData.mensaje));
            return;
          }
          return respuesta;
        }

        ).catch(function (error) {
         // console.log(error)
         
          authService.logout()
        })
    );

  
  }

  render() {
    var ejercicio = this.state.listaEjercicio;
    if (this.state.listaEjercicio.length === 0)
      ejercicio = this.obtenerEjercicio()

    return (
      <div className="content-wrapper">
        <Titulo texto="Excedentes" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                      <label className="input-label-bold">Seleccione el ejercicio *</label>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          
                          <Select
                            required="true"
                            placeholder="-- Seleccione --"
                            onChange={this.handleChangeEjercicioSelector}
                            options={ejercicio}
                            isClearable
                            noOptionsMessage={() => "SIN DATOS"}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                      <button className="btn btn-cu-primary" onClick={() => this.getListaResumen()} ><FontAwesomeIcon icon={faCheck} /> Consultar</button>
                      </div>
                    </div>
                  </div>
                 
                </div>
              </div>
            </div>
            {this.getEjercicioExcedente()}
          </div>
        </section>
      </div>
    );
  }
}
